{
  "cms.homeCard.field.title": "Title",
  "cms.homeCard.field.imageUrl": "Image",
  "cms.homeCard.field.tab": "Home page tab",
  "cms.homeCard.field.size": "Card size",
  "cms.homeCard.size.small": "Small",
  "cms.homeCard.size.large": "Large",
  "cms.homeCard.tab.lakikaveri": "Lakikaveri",
  "cms.homeCard.tab.palvelut": "Membership & benefits",
  "cms.homeCard.error.titleRequired": "Title is required.",
  "cms.homeCard.error.imageRequired": "Image is required.",
  "cms.homeCard.error.imageUrl": "Image URL must start with https:// or be a same-origin path (/media/...)."
}
